import React from 'react';
import classNameBind from 'classnames/bind';
import {
  Button, Image, Logo, ThemeContext, useTranslation,
} from '@piwikpro/ui-components';
import styles from './LogoAndFaviconPreview.module.css';

const bindClasses = classNameBind.bind(styles);

interface LogoAndFaviconPreviewProps {
  instanceAddress?: string
  logo: string
  favicon: string
}

export const LogoAndFaviconPreview = ({
  instanceAddress = document.location.origin,
  logo,
  favicon,
}: LogoAndFaviconPreviewProps) => {
  const themeContext = React.useContext(ThemeContext);
  const { t } = useTranslation();

  return (
    <div className={bindClasses('background', themeContext)}>
      <div data-ppuc-id="favicon-preview" className={bindClasses('favicon')}>
        <Image src={favicon} />
      </div>
      <div className={bindClasses('instanceAddress')}>{instanceAddress}</div>
      <div data-ppuc-id="logo-preview" className={bindClasses('productBar')}>
        <Button appearance="subdued" icon="menu" />
        <Logo src={logo} />
        <div className={styles.moduleName}>
          {t('moduleName')}
        </div>
      </div>
    </div>
  );
};
